module.exports = __webpack_public_path__ + "static/media/CT.c39d46ec.png";